export function contentEditableEvents({ maxlength, allowLineBreak = false }: { maxlength: number; allowLineBreak?: boolean }) {
  const { $clientJS } = useNuxtApp()

  function clampTextLength(text: string, fullText: string, e: InputEvent): string {
    const [range] = e.getTargetRanges()
    const availableSpace = maxlength - fullText.length + range.endOffset - range.startOffset
    return text.slice(0, availableSpace)
  }

  return {
    handleInputEvent(e: InputEvent) {
      const inputElement = e.currentTarget as HTMLElement

      // prevents infinite loop in Safari (document.execCommand will trigger an InputEvent as well)
      if ($clientJS.isSafari() && e.inputType === 'insertText') {
        const textLength = inputElement.innerText?.length
        const [range] = e.getTargetRanges()
        const selectedRangeLength = range.endOffset - range.startOffset
        if (textLength && textLength - selectedRangeLength >= maxlength) {
          e.preventDefault()
        }
        return
      }

      if (!/^insert/.test(e.inputType)) return
      if (allowLineBreak && e.inputType === 'insertLineBreak' && inputElement.innerText?.length < maxlength) return

      e.preventDefault()

      let text = e.data ?? ''

      // For clipboard events and drag & drop
      if (!e.data && e.dataTransfer instanceof DataTransfer) {
        text = e.dataTransfer.getData('text/plain')
      }

      text = clampTextLength(text, inputElement.innerText ?? '', e)

      if (text.length === 0) return true

      // This is deprecated, but it is the only solution which preserves browser undo functionality.
      // https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand
      document.execCommand('insertText', undefined, text)

      // // Below is a non-deprecated solution. If the undo issue is fixed, we can use this.
      // const currentText = inputElement.textContent ?? ''
      // const [range] = e.getTargetRanges()
      //
      // // insert 3 text nodes
      // inputElement.replaceChildren(currentText.slice(0, range.startOffset), text, currentText.slice(range.endOffset))
      //
      // // range.setStart(inputElement.childNodes[0], 2)
      //
      // // offset is the offset of the text node, not character count
      // document.getSelection()?.setPosition(inputElement, 2)
      //
      // inputElement.normalize()
    },

    insertLineBreakIfAllowed(e: KeyboardEvent) {
      const inputElement = e.currentTarget as HTMLElement
      if (allowLineBreak && inputElement.innerText?.length < maxlength) {
        e.preventDefault()

        // This is deprecated, but it is the only solution which preserves browser undo functionality.
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand
        document.execCommand('insertLineBreak')
      }
    },
  }
}
